var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ship-vetting-container"},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[(_vm.pageStatus == 0)?_c('div',[_c('HoldingCertList',{staticClass:"barging-container"})],1):_vm._e(),(_vm.pageStatus == 1 || _vm.pageStatus == 2)?_c('div',[_c('HoldingCertDetail',{staticClass:"top2"})],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }